import { BaseButton } from '@/components/Buttons/Core/BaseButton';
import { withStyles } from '@/components/Buttons/Core/withStyles';

export const DefaultButton = withStyles(BaseButton, {
    light: 'muted.100',
    dark: 'muted.800',
    
    textStyle: {
        light: 'muted.900',
        dark: 'muted.100',
        variant: ['regular']
    }
});